import React, {useEffect, useState } from "react";
import { getAllCalls, addCall, getAllLeads } from "../../utils/helper";
import Loader from "../../utils/Loader";
// import { useHistory } from "react-router-dom";
import { alertSuccess, alertError } from '../../utils/alerts';
import { Link } from "react-router-dom/cjs/react-router-dom";

const INIT_STATE = {
    lead: null,
    leadStage: "",
    activityDate: null,
    nextActivityDate: null,
    activityType: null,
    summary: null,
    justification: null,
};

export default function Calls() {
    const [loading, setLoading] = useState(false);
    const [calls, setCalls] = useState(null);
    const [leads, setLeads] = useState(null);
    // const history = useHistory();
    const [state, setState] = useState(INIT_STATE);

    useEffect(() => {
        setLoading(true);
        getAllCalls()
            .then((res) => { 
                setCalls(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    useEffect(() => {
        getAllLeads()
            .then((res) => {
                if(res.data.success){
                    setLeads(res.data.data);  
                } 
            })
            .catch((err) => {
                console.log(err?.response)
            });
    }, []);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state };
        if(data.lead && data.activityDate && data.nextActivityDate && data.activityType && data.summary && data.leadStage
            && data.justification
        ){
            setLoading(true);
            addCall(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message);
                    window.location.reload();
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                setTimeout(() => {
                    setLoading(false);
                }, 1500);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
                setLoading(false);
            });
        }
    };

    return (
        <>
            <div className="spur-card-menu">
                <button data-toggle="modal" data-target="#modal" type="button" className="pull-right btn topbtn btn-primary">CREATE</button>
            </div>
            
            <h1 className="dash-title"><Link to="/sales" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Sales Calls</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && calls && calls) ? 
                                    <div className="table-responsive">
                                        {(calls && calls.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Customer</th><th>Contact</th><th>Lead Stage</th><th>Summary</th><th>Activity Date</th><th>Activity Type</th></tr></thead>
                                            <tbody>
                                                {calls && calls.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.lead && row?.lead?.customer?.name}</td>
                                                        <td>{row?.lead && row?.lead?.contact && row?.lead?.contact?.name}</td>
                                                        <td>{row?.lead && row?.lead?.stage}</td>
                                                        <td>{row?.summary && row?.summary}</td>
                                                        <td>{row?.activityDate && row?.activityDate}</td>
                                                        <td>{row?.activityType && row?.activityType}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD SALES CALL</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Lead <span>*</span></label>
                                    <select className="form-control form-select" name="lead" id="lead" required 
                                    onChange={handleChange} defaultValue={state.lead && state.lead} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {leads && leads.map((item, i) => (
                                            <option key={i} value={item._id}>CUSTOMER: {item.customer?.name}, 
                                            SERVICE: {item.service}, STAGE: {item.stage}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Activity Date <span>*</span></label>
                                    <input type="date" name="activityDate" className="form-control" required 
                                        placeholder="Activity Date" 
                                        onChange={handleChange} 
                                        defaultValue={state.activityDate && state.activityDate }  disabled={loading} 
                                    />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Next Activity Date <span>*</span></label>
                                    <input type="date" name="nextActivityDate" className="form-control" required 
                                        placeholder="Next Activity Date" 
                                        onChange={handleChange} 
                                        defaultValue={state.nextActivityDate && state.nextActivityDate }  disabled={loading} 
                                    />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Activity Type <span>*</span></label>
                                    <select className="form-control form-select" name="activityType" id="activityType" required 
                                    onChange={handleChange} defaultValue={state.activityType && state.activityType} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="Email">Email</option>
                                        <option value="Phone Call">Phone Call</option>
                                        <option value="Physical Meeting">Physical Meeting</option>
                                        <option value="Outbound Call">Outbound Call</option>
                                        <option value="Inbound Call">Inbound Call</option>
                                        <option value="Presentation">Presentation</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">New Lead Stage: <span>*</span></label>
                                    <select className="form-control form-select" name="leadStage" id="leadStage" required 
                                    onChange={handleChange} defaultValue={state.leadStage && state.leadStage} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="suspect">Suspect</option>
                                        <option value="prospect">Prospect</option>
                                        <option value="opportunity">Opportunity</option>
                                        <option value="won">Won</option>
                                        <option value="lost">Lost</option>
                                    </select>
                                </div>
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Justification for Change: <span>*</span></label>
                                    <input type="text" name="justification" className="form-control" required 
                                        placeholder="Justification (Enter NA if not applicable)" onChange={handleChange} 
                                        defaultValue={state.justification && state.justification }  disabled={loading} 
                                    />
                                </div>
                                
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Summary/Comments/Notes: <span>*</span></label>
                                    <textarea cols="33" rows="3" name="summary" className="form-control" required 
                                    placeholder="Summary/Comments/Notes" 
                                        onChange={handleChange} defaultValue={state.summary || ""} >    
                                    </textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmit} >Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
